<template>
    <!--Help content-->
    <div class="myskov-help">
        <div class="myskov-help__header">
            <h2 v-text="translations.title"></h2>
            <p v-text="translations.sub_title"></p>
        </div>
        <div class="myskov-help__content">
            <div class="myskov-help-block">
                <div class="myskov-help-block__icon myskov-help-block__icon--heart">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.01 28.01">
                        <path d="M22.81,2a7.19,7.19,0,0,1,4.84,12.52l0,0,0,0-10,10A9.42,9.42,0,0,1,16,26a9.81,9.81,0,0,1-1.58-1.39l-10-10,0,0,0,0A7.19,7.19,0,1,1,14.52,4.36L16,6l1.48-1.63A7.23,7.23,0,0,1,22.81,2m0-2A9.16,9.16,0,0,0,16,3,9.19,9.19,0,1,0,3,16L13,26c1,1,2,2,3,2s2-1,3-2L29,16A9.19,9.19,0,0,0,22.81,0Z"/>
                    </svg>
                </div>
                <div class="myskov-help-block__text">
                    <h3 v-text="translations.saved_offers_title"></h3>
                    <p v-html="translations.saved_offers_content"></p>
                    <router-link to="/myskov/offers" v-text="translations.saved_offers_link"></router-link>
                </div>
            </div>
            <div class="myskov-help-block">
                <div class="myskov-help-block__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.2 47.5">
                        <path d="M20.9,39.71a2.09,2.09,0,1,1-2.09,2.09A2.1,2.1,0,0,1,20.9,39.71Zm19,0a2.09,2.09,0,1,1-2.09,2.09A2.1,2.1,0,0,1,39.9,39.71ZM13.75,15.2l-1.19-3.8H22.8v3.8ZM26.6,26.6h9.5v3.8H26.6Zm0-7.6h9.5v3.8H26.6Zm0-7.6h9.5v3.8H26.6ZM39.9,26.6h5.17l-1,3.8H39.9Zm0-7.6H47L46,22.8H39.9Zm0-7.6h9l-1,3.88a1.89,1.89,0,0,0-.4-.08H39.9ZM22.8,22.8H16.12L14.93,19H22.8Zm0,7.6H18.5l-1.19-3.8H22.8Zm-5.7,3.8H45.6a1.89,1.89,0,0,0,1.84-1.44L53.14,10a1.87,1.87,0,0,0-.34-1.63,1.9,1.9,0,0,0-1.5-.73H11.37l-2-6.27A1.89,1.89,0,0,0,7.6,0H1.9a1.9,1.9,0,0,0,0,3.8H6.2l8.42,27a6.57,6.57,0,0,0-5.12,6.3,6.67,6.67,0,0,0,6,6.51,5.66,5.66,0,0,0,10.74.14h8.3a5.67,5.67,0,0,0,10.7,0H47.5a1.9,1.9,0,0,0,0-3.8H45.25a5.67,5.67,0,0,0-10.7,0h-8.3a5.68,5.68,0,0,0-10.64-.2,2.8,2.8,0,0,1-2.31-2.65C13.3,35.63,14.47,34.2,17.1,34.2Z"/>
                    </svg>
                </div>
                <div class="myskov-help-block__text">
                    <h3 v-text="translations.my_orders_header"></h3>
                    <p v-html="translations.my_orders_content"></p>
                    <router-link to="/myskov/orders" v-text="translations.my_orders_link"></router-link>
                </div>
            </div>
            <div class="myskov-help-block">
                <div class="myskov-help-block__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.04 26.96">
                        <path d="M26,27H1a1,1,0,0,1-.59-1.81,21.19,21.19,0,0,1,7.94-3.54,1,1,0,0,0,.83-1c0-.54,0-1.12,0-1.73a5.16,5.16,0,0,0-.79-2.21,6.94,6.94,0,0,1-1-2.78,7.83,7.83,0,0,1-.87-3.18,1.65,1.65,0,0,1,.4-1.22c-.07-.34-.13-.7-.19-1.06l0-.17c-.06-.37-.12-.71-.18-1C6,4.11,7,2.18,9.78.92L9.9.85A6.56,6.56,0,0,1,12.55.06a7.45,7.45,0,0,1,3.26.32l.37.09c.44.11.79.21,1,.28,2.72,1,3.9,3.26,3.33,6.45-.07.35-.12.7-.18,1s-.14.83-.22,1.23a1.65,1.65,0,0,1,.4,1.22,7.7,7.7,0,0,1-.88,3.18,7,7,0,0,1-1,2.86,5.13,5.13,0,0,0-.76,2.14c0,.6,0,1.18,0,1.73a1,1,0,0,0,.83,1,21.21,21.21,0,0,1,7.93,3.54A1,1,0,0,1,26,27ZM4.65,25H22.39a16,16,0,0,0-4.05-1.38,3,3,0,0,1-2.48-3.07c0-.52,0-1.07,0-1.64a6.67,6.67,0,0,1,1-3.06,5.89,5.89,0,0,0,.77-2,2.08,2.08,0,0,1,.19-.77,6,6,0,0,0,.68-2.31v0a2,2,0,0,1-.36-1.56c.07-.38.14-.78.2-1.19s.12-.71.19-1.07c.53-2.94-.9-3.8-2-4.2-.17-.06-.47-.14-.83-.23l-.38-.09a5.53,5.53,0,0,0-2.54-.27,4.59,4.59,0,0,0-2,.59l-.17.09c-2,.9-2.53,1.93-2.14,4.11l.18,1,0,.21q.09.53.18,1a2,2,0,0,1-.36,1.56v0A5.86,5.86,0,0,0,9.21,13a2,2,0,0,1,.19.77,5.3,5.3,0,0,0,.75,2,6.94,6.94,0,0,1,1,3.15c0,.57,0,1.12,0,1.64A3,3,0,0,1,8.7,23.58,16,16,0,0,0,4.65,25Zm3.7-14.09h0Zm10.34,0Z"/>
                    </svg>
                </div>
                <div class="myskov-help-block__text">
                    <h3 v-text="translations.profile_title"></h3>
                    <p v-text="translations.profile_content"></p>
                    <router-link to="/myskov/profile" v-text="translations.profile_link"></router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            translations: APP_CONFIG.TRANSLATION.MYSKOV_HELP
        }
    }
}
</script>
